(() => {
  let dialog, lastTrigger, pausedPreviews = [];
  function closeVideo() { dialog?.close(); }
  function openVideo(trigger, content) {
    if (!dialog) {
      dialog = document.createElement('dialog');
      dialog.className = 'pg-modal';
      dialog.setAttribute('aria-label', 'Full video');
      dialog.innerHTML = '<button type="button" class="pg-modal-close" aria-label="Close video">Close ×</button><div class="pg-modal-body"></div>';
      document.body.append(dialog);
      dialog.querySelector('button').addEventListener('click', closeVideo);
      dialog.addEventListener('click', e => { if (e.target === dialog) closeVideo(); });
      dialog.addEventListener('close', () => {
        dialog.querySelector('.pg-modal-body').replaceChildren();
        pausedPreviews.forEach(v => { if (v.isConnected && v.getClientRects().length) v.play().catch(() => {}); });
        pausedPreviews = [];
        lastTrigger?.focus({preventScroll: true});
      });
    }
    lastTrigger = trigger;
    pausedPreviews = [...document.querySelectorAll('[data-pg-video-preview] video')].filter(v => !v.paused);
    pausedPreviews.forEach(v => v.pause());
    dialog.querySelector('.pg-modal-body').replaceChildren(content);
    dialog.showModal();
    dialog.querySelector('video')?.play().catch(() => {});
  }
  function syncPreviews() {
    document.querySelectorAll('[data-pg-video-preview] video').forEach(v => {
      v.controls = false;
      v.muted = true;
      if (!v.getClientRects().length) v.pause();
      else {const r=v.getBoundingClientRect();const visible=r.bottom>0&&r.top<window.innerHeight&&r.right>0&&r.left<window.innerWidth;if((v.autoplay||v.dataset.pgAutoplay==='true')&&visible&&!dialog?.open)v.play().catch(()=>{});else v.pause();}
    });
  }
  let pgPreviewFrame;window.addEventListener('scroll',()=>{cancelAnimationFrame(pgPreviewFrame);pgPreviewFrame=requestAnimationFrame(syncPreviews);},{passive:true,capture:true});
  function init() {
    document.querySelectorAll('.accessory-hero,.pdp-purchase').forEach(hero => {
      const input = hero.querySelector('.pg-quantity-input'), form = hero.querySelector('form');
      if (input && form) {
        form.id = form.id || 'pg-accessory-' + input.getAttribute('data-shopify-block-id');
        input.setAttribute('form', form.id);
        form.querySelector('input[type=hidden][name=quantity]')?.remove();
      }
    });
    document.querySelectorAll('.faq-q').forEach(q => q.setAttribute('aria-expanded', q.closest('.faq-item').classList.contains('open')));
    document.querySelectorAll('.nav').forEach(nav => {
      if (!nav.querySelector('.pg-menu-toggle')) {
        const b = document.createElement('button');
        b.type = 'button'; b.className = 'pg-menu-toggle';
        b.setAttribute('aria-label', 'Open menu'); b.setAttribute('aria-expanded', 'false'); b.textContent = '☰'; nav.append(b);
      }
    });
    syncPreviews();
  }
  document.addEventListener('click', e => {
    const full = e.target.closest('[data-pg-full-video]');
    if (full) {
      e.preventDefault();
      const source = document.getElementById(full.dataset.pgFullVideo);
      if (source instanceof HTMLTemplateElement) openVideo(full, source.content.cloneNode(true));
      return;
    }
    const menu = e.target.closest('.pg-menu-toggle');
    if (menu) {
      const open = menu.closest('.nav').classList.toggle('pg-open');
      menu.setAttribute('aria-expanded', open); menu.setAttribute('aria-label', open ? 'Close menu' : 'Open menu'); return;
    }
    const faq = e.target.closest('.faq-q');
    if (faq) {
      faq.setAttribute('aria-expanded', faq.closest('.faq-item').classList.toggle('open')); return;
    }
    const video = e.target.closest('[data-video-id]');
    if (video) {
      e.preventDefault();
      const frame = document.createElement('iframe');
      frame.title = 'Full video'; frame.allow = 'autoplay; encrypted-media; picture-in-picture; fullscreen'; frame.allowFullscreen = true;
      const id = encodeURIComponent(video.dataset.videoId);
      frame.src = video.dataset.videoType === 'vimeo' ? 'https://player.vimeo.com/video/' + id + '?autoplay=1&controls=1' : 'https://www.youtube-nocookie.com/embed/' + id + '?autoplay=1&controls=1&rel=0';
      openVideo(video, frame); return;
    }
    const link = e.target.closest('[data-link]');
    if (link) {
      const href = link.dataset.link;
      if (href.startsWith('#')) document.getElementById(href.slice(1))?.scrollIntoView({behavior: matchMedia('(prefers-reduced-motion:reduce)').matches ? 'auto' : 'smooth'});
      else location.href = href;
      return;
    }
    const arrow = e.target.closest('.review-prev,.review-next');
    if (arrow) {
      const track = arrow.closest('.customer-reviews')?.querySelector('.review-track');
      if (track) track.scrollBy({left: (arrow.matches('.review-next') ? 1 : -1) * track.clientWidth * .8, behavior: 'smooth'});
    }
  });
  document.addEventListener('keydown', e => {
    if (e.key === 'Escape') document.querySelectorAll('.nav.pg-open').forEach(n => {
      n.classList.remove('pg-open'); n.querySelector('.pg-menu-toggle')?.setAttribute('aria-expanded', 'false');
    });
  });
  document.addEventListener('shopify:section:load', init);
  document.addEventListener('shopify:section:unload', closeVideo);
  document.addEventListener('shopify:block:select', e => e.target.closest('.faq-item')?.classList.add('open'));
  matchMedia('(min-width:769px)').addEventListener('change', syncPreviews);
  document.addEventListener('DOMContentLoaded', init);
  init();
})();
